import { call, put, select, race, delay } from 'redux-saga/effects';
import { getItem as getItemPromise } from '@gc-npm/adabyron.catalogue.get-item';
// import { getItem as getItemPromise } from '@/sagas/saga-temp/get-item';
import { actions as detailedProductActions } from '@/reducers/detailed-product-reducer';
import {
  normalizeSingleProduct,
  findKeysWithAliasUrl,
} from '@/utils/normalizers/detailed-product';

const contextStore = (state) => state.main.context;

export function* getItem(args) {
  try {
    const { data, build } = args.payload;
    const { alias } = data;
    const context = yield select(contextStore); 
    const response =yield call(getItemPromise, { data, context, build });
    
    const responseNormalize = normalizeSingleProduct(response);
    let mainColorCapacityName;
    if (responseNormalize && responseNormalize.offers) {
      mainColorCapacityName = findKeysWithAliasUrl(responseNormalize.offers, alias);
    }

    yield put(
      detailedProductActions.getDetailedProductSuccess({
        response: responseNormalize,
        capacityColorName: mainColorCapacityName,
      })
    );
  } catch (error) {
    yield put(detailedProductActions.getDetailedProductError());
    console.log('getItem Error', error);
  }
}
